/* Mr Pixel — pause the home page reviews marquee on tap (touch only).

   The marquee itself is pure CSS (assets/section-mp-home.css, the judge.me
   block) and pausing on a hover-capable pointer is pure CSS too, off
   `.jdgm-cards-wrapper:hover`. This file exists only for touch, where there
   is no hover state to key off: tapping the reviews pauses them, tapping
   anywhere else lets them continue — Jordan, 2026-09-01.

   Delegated at document level rather than bound per widget on purpose: the
   judge.me app block builds and can rebuild its own DOM, so there is nothing
   stable to bind to at load time, and a delegated listener needs no init,
   no MutationObserver and no re-binding. */

(function () {
  'use strict';

  var WIDGET = '.jdgm-widget.jdgm-cards-carousel';
  var PAUSED = 'is-mp-paused';

  document.addEventListener('click', function (event) {
    /* Hover-capable pointers already pause via CSS. Bailing here also keeps a
       mouse click — which opens judge.me's own review lightbox — from latching
       a pause that only another click could clear. */
    if (window.matchMedia('(hover: hover)').matches) return;

    var target = event.target;
    if (!target || !target.closest) return;

    /* judge.me appends its review lightbox to <body>, i.e. OUTSIDE the widget,
       so without this a tap inside the lightbox would read as "tapped away"
       and resume the marquee running behind it. */
    if (target.closest('.jdgm-modal')) return;

    var tapped = target.closest(WIDGET);
    var widgets = document.querySelectorAll(WIDGET);

    for (var i = 0; i < widgets.length; i++) {
      if (widgets[i] === tapped) {
        widgets[i].classList.add(PAUSED);
      } else {
        widgets[i].classList.remove(PAUSED);
      }
    }
  });
})();
